import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Tone = "ink" | "amber" | "pine" | "slate";

const toneClass: Record<Tone, string> = {
  ink: "stamp-ink",
  amber: "stamp-amber",
  pine: "stamp-pine",
  slate: "stamp-slate",
};

export function Stamp({
  children,
  tone = "ink",
  className,
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return <span className={cn("stamp", toneClass[tone], className)}>{children}</span>;
}
